import React, { memo } from 'react';
import { Box, Button, Image, Text } from '@bonanza-social/moonlight';
import { DailyGiftPendingProps } from './DailyGiftPending.types';

function DailyGiftPending({
  onPress,
  isClaiming,
  type,
}: DailyGiftPendingProps) {
  const isLockedType = type === 'locked';

  return (
    <Box
      alignItems="center"
      gap="space-600"
      height="100%"
      justifyContent="space-between"
      position="relative"
    >
      {isLockedType && (
        <Box
          alignItems="center"
          justifyContent="center"
          padding="space-300"
          backgroundColor="mutedBackground"
          borderRadius="radius-full"
          position="absolute"
          top="-space-200"
          left="-space-200"
        >
          <Image name="common.Lock" width={24} height={24} />
        </Box>
      )}
      <Text
        variant="h4"
        color="accentSurfacePrimary"
        locNS="dailyGift"
        locKey="pendingTitle"
        textAlign="center"
      />
      <Image name="common.BonanzaCoinStack" width={200} height={155} />
      <Button
        width="100%"
        light
        variant="primary"
        locNS="dailyGift"
        locKey={isLockedType ? 'lockedCta' : 'pendingCta'}
        onPress={onPress}
        loading={isClaiming}
      />
    </Box>
  );
}

export default memo(DailyGiftPending);
